module.exports = __webpack_public_path__ + "img/front_8.37c46b66.svg";